import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Test from '../Test/Test';
import './index.css';
import RightIconMenu from "../RightIconMenu";

export default class View_type_11 extends Component{

	constructor(props){
		super(props);

		let data = {article: [], right_menu: [], ...props.data};
		let config = {config: [], ...props.config};

		this.state = {
			data: data,
			rightMenu: data.right_menu,
			config: config,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		}

		// console.log(this.state);

	}

	render(){
		// console.log(this.state.data.article.length);
		if(!this.state.data.article){
			return null;
		}

		var mobile_lead = this.state.data.lead ? <div className="vt11 mobile_lead"><div className="vt11 mobile_lead_inner" dangerouslySetInnerHTML={{ __html: this.state.data.lead }}></div></div> : null;
		var about_text_style = this.state.data.lead ? {paddingTop: 15} : null;

		return (
			<div className="vt11">
			<div className="vt11 about_title artists-pageTitle" dangerouslySetInnerHTML={{ __html: this.state.data.title }}></div>
				<div className="vt11 about-topbanner-box">

							<div className="vt11 about_img_block" style={{backgroundImage: "url(" + this.state.data.article.cover_photo + ")"}}>
								<div className="vt11 about-colorbox" style={{backgroundColor: '#'+this.state.config.gbcolor}}></div>
							</div>
				</div>

				<div className="vt11 about-content left col-xs-12 col-sm-10 col-md-9 col-lg-9">
					<div className="vt11 mobileMenu">
						<ul>
							{this.state.rightMenu.map(function(object, i){
								return (<li className="vt11 about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>

					{mobile_lead}

					<div className="vt11 about_text" style={about_text_style} dangerouslySetInnerHTML={{ __html: this.state.data.text }}></div>

				</div>
				<div className="vt11 right col-xs-2 col-sm-2 col-md-3 col-lg-3">

					<div className="vt11 disctopMenuright">
						<ul>
							{this.state.rightMenu.map(function(object, i){

							return (<li className="vt11 about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}


				</div>
			</div>
		);



	}

}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_11/index.js